<template>
    <div class="rounded-md">
        <div class="relative overflow-hidden">
            <Rings
                :oForm="oForm"
                :risk="history.risk"
                :segmentsModel="history.segments"
                :rotateNum="rotateNum"
                :once-bet="onceBet"
                :animation="false"
                :isFast="false"
                :is-win="true"
                :result-show="false"
                :win-amount="Number(history.winAmount)"
            />
            <Pickers
                :rotate-num="rotateNum"
                :risk="history.risk"
                :segments="history.segments"
                :onceBet="onceBet"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import Rings from '~/pages/casino/ringGame/_components/Rings/index.vue';
import Pickers from '~/pages/casino/ringGame/_components/Pickers.vue';
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';

const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
        required: true,
    },
});

const oForm = ref({
    amount: 0,
    isSubmiting: false,
});

const onceBet = ref(true);

const rotateNum = Number(props.history.randomSeed.replace(/_.+/, ''));
</script>
